module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "content-area-full"
  }, [_c('div', {
    staticClass: "dept_content clearfix"
  }, _vm._l((_vm.entries), function(entry, index) {
    return _c('div', {
      key: _vm.entryKey(entry, index),
      staticClass: "card-section"
    }, [_c('div', {
      staticClass: "card-section-wrapper",
      attrs: {
        "id": _vm.entryKey(entry, index)
      }
    }, [_c('div', {
      staticClass: "img-box"
    }, [_c('img', {
      attrs: {
        "src": entry.cover == null ? _vm.url + '/assets/upload/' + entry.imgs_url.split(';')[0] : _vm.url + '/assets/upload/' + entry.cover,
        "oncontextmenu": "return false;",
        "ondragstart": "return false;",
        "oncopy": "return false;",
        "onselect": "return false"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "con-box"
    }, [_c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("作品年份：")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(entry.year))])]), _vm._v(" "), _c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("作品序号：")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(entry.eid))])]), _vm._v(" "), _c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("作品名称：")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(entry.name))])]), _vm._v(" "), _c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("作者姓名：")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(entry.username))])]), _vm._v(" "), _c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("所属学校：")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(entry.school))])]), _vm._v(" "), _c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("所在年级：")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(_vm.convertGrade(entry.gid)))])]), _vm._v(" "), _c('div', {
      staticClass: "info-row"
    }, [_c('span', {
      staticClass: "label"
    }, [_vm._v("指导老师：")]), _vm._v(" "), _c('span', {}, [_vm._v(_vm._s(entry.teacher))])]), _vm._v(" "), (_vm.expandedEntryKey == _vm.entryKey(entry, index)) ? _c('div', {
      staticClass: "primary-btn checkmore",
      on: {
        "click": function($event) {
          return _vm.collapseEntry()
        }
      }
    }, [_vm._v("收起作品")]) : _c('div', {
      staticClass: "primary-btn checkmore",
      on: {
        "click": function($event) {
          return _vm.checkmore(entry, index)
        }
      }
    }, [_vm._v(" 查看作品")])])]), _vm._v(" "), (_vm.expandedEntryKey == _vm.entryKey(entry, index)) ? _c('div', {
      staticClass: "imgs-box"
    }, [_vm._l((entry.imgs_url.split(';')), function(entryImg, index) {
      return _c('div', {
        key: index,
        staticClass: "img-box"
      }, [_c('img', {
        attrs: {
          "src": _vm.url + '/assets/upload/' + entryImg,
          "oncontextmenu": "return false;",
          "ondragstart": "return false;",
          "oncopy": "return false;",
          "onselect": "return false"
        }
      })])
    }), _vm._v(" "), (entry.videos_url) ? _c('div', _vm._l((entry.videos_url.split(';')), function(entryVideo, index) {
      return _c('div', {
        key: index,
        staticClass: "img-box",
        attrs: {
          "oncontextmenu": "return false;",
          "ondragstart": "return false;",
          "oncopy": "return false;",
          "onselect": "return false"
        }
      }, [_c('div', {
        staticClass: "zhezhao"
      }), _vm._v(" "), _c('video', {
        staticStyle: {
          "width": "960px"
        },
        attrs: {
          "controls": ""
        }
      }, [_c('source', {
        attrs: {
          "src": _vm.url + '/assets/upload/' + entryVideo,
          "type": "video/mp4"
        }
      }), _vm._v("\n                      当前浏览器不支持该视频格式\n                  ")])])
    }), 0) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "collapse-btn toclick",
      on: {
        "click": function($event) {
          return _vm.collapseEntry(entry, index)
        }
      }
    }, [_vm._v("收起作品")])], 2) : _vm._e()])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0858a1e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Entry.vue
// module id = 610
// module chunks = 1